import Vue from 'vue'
import Vuex from 'vuex'
import httpApi from './api'

Vue.use(Vuex)

httpApi.defaults.activeApiCalls = {}

httpApi.interceptors.request.use(
  async config => {
    console.log("   request", config.baseURL+config.url)
    store.commit('SET_API_CALL_PROGRESS',  { url: config.baseURL + config.url, add: true })
    config.headers.Authorization = await localStorage.jwt;
    return config;
  },
  error => {
    console.warn("   request", error.config.baseURL)
    store.commit('SET_API_CALL_PROGRESS', { url: error.config.baseURL + error.config.url, add: false })
    return Promise.reject(error);
  }
);

httpApi.interceptors.response.use(
  config => {
    console.log("   response", config.config.url)
    store.commit('SET_API_CALL_PROGRESS', { url: config.config.url, add: false })
    // delete config.activeApiCalls[config.config.url]
    return config
  },
  error => {
    console.warn("   response", error.config.url)
    store.commit('SET_API_CALL_PROGRESS', { url: error.config.url, add: false })
    return Promise.reject(error);
  }
);


const store = new Vuex.Store({
  state: {
    jwtIsVerified: false,
    apiCallsInProgress: {},
    user: {
      username: 'Guest',
      fullname: '',
      admin: false
    }
  },
  mutations: {
    SET_JWT_VALIDITY (state, bool = false) {
      state.jwtIsVerified += bool
    },
    SET_USER_DETAILS (state, { username, fullname, is_admin }) {
      state.user.username = username
      state.user.fullname = fullname
      state.user.admin = is_admin
    },
    SET_API_CALL_PROGRESS (state, { url, add = false }) {
      // console.log("SET_API_CALL_PROGRESS@@@", add, url)
      if (add) {
        state.apiCallsInProgress[url] = true
      } else {
        delete state.apiCallsInProgress[url]
      }
      // force UI to be reactive
      // state.apiCallsInProgress = Object.assign({}, state.apiCallsInProgress)
      state.apiCallsInProgress = { ...state.apiCallsInProgress }
    }
  },
  actions: {
    verifyJWT (context, bool) {
      context.commit('SET_JWT_VALIDITY', bool)
    },
    updateUserDetails (context, payload) {
      context.commit('SET_USER_DETAILS', payload)
    },

  },
  getters: {
    apiCallsInActive: state => Boolean(Object.keys(state.apiCallsInProgress).length)
  }
})


export default store